import React from 'react'
import DialogCloseIconButton from './DialogCloseIconButton'

export * from './DialogCloseIconButton'
export default React.memo(DialogCloseIconButton)
